import { IStringValue } from 'model/FlexibleAttributeModel';
import React from 'react';

interface IProps {
    [key: string]: any;
    defaultFieldValue?: IStringValue;
}

// Constants: HTML detection
const HTML_DIV_START = '<div'

// Constants: Container styles
const messageContainerStyle: React.CSSProperties = {
    display: 'flex',
    gap: '8px',
    backgroundColor: '#007bff',
    padding: '8px',
    borderRadius: '4px',
    alignItems: 'center'
}

// Constants: Text styles
const messageTextStyle: React.CSSProperties = {
    color: 'white',
    fontSize: '14px',
    fontWeight: 'bold'
}

// MessageControl component with React.memo(). This memoizes the component so it only re-renders if its props actually change. Without it, the component would re-render every time its parent renders, even if the props passed to MessageControl are identical.
const MessageControl: React.FC<IProps> = React.memo((props) => {
    const { defaultFieldValue } = props

    if (defaultFieldValue?.value.startsWith(HTML_DIV_START)) {
        return <div dangerouslySetInnerHTML={{ __html: defaultFieldValue.value }} />
    }

    return (
        <div style={messageContainerStyle}>
            <div style={messageTextStyle}>
                {defaultFieldValue?.value || ''}
            </div>
        </div>
    )
})

MessageControl.displayName = 'MessageControl'

export default MessageControl